import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TransportLocationsDetailsComponent } from './transport-locations-details.component';

@Injectable({
  providedIn: 'root'
})
export class TransportLocationsDetailsCanDeactivate  {
  canDeactivate(
    component: TransportLocationsDetailsComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return component.canDeactivate();
  }
}
